import { Guid, Nillable } from '@web/utils';
import { AdminBrandStatus, BrandSocialMedia } from '@web/shared/module/brand';

export class AdminBrandDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      description?: Nillable<string>;
      homeUrl?: Nillable<string>;
      id: Guid;
      illustrationAlt?: Nillable<string>;
      illustrationSrc?: Nillable<string>;
      name: string;
      socials: BrandSocialMedia[];
      status: AdminBrandStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): Nillable<string> {
    return this.data.description;
  }

  public get homeUrl(): Nillable<string> {
    return this.data.homeUrl;
  }

  public get illustrationAlt(): Nillable<string> {
    return this.data.illustrationAlt;
  }

  public get illustrationSrc(): Nillable<string> {
    return this.data.illustrationSrc;
  }

  public get socials(): BrandSocialMedia[] {
    return this.data.socials;
  }

  public get status(): AdminBrandStatus {
    return this.data.status;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public isPrivate(): boolean {
    return this.status === AdminBrandStatus.Private;
  }

  public isDraft(): boolean {
    return this.status === AdminBrandStatus.Draft;
  }

  public isPublic(): boolean {
    return this.status === AdminBrandStatus.Public;
  }
}
